enum AlertStateEnum {
  DETECTED = 'detectado',
  IN_PRE_TRIAGE = 'em_pre_triagem',
  SELF_RESOLVED = 'autorresolvido',
  ESCALATED = 'escalado',
  IN_QUEUE = 'na_fila',
  IN_SERVICE = 'em_atendimento',
  TREATED = 'tratado',
  /** Gravado sem fila — paciente de tenant sem equipe contratada. */
  RECORDED = 'registrado',
}

export default AlertStateEnum;
